interface IDCLProfile {
    avatar: IAvatar;
    name: string;
}


export interface IAvatar {
    body: string;
    face: string;
    face128: string;
    face256: string;
}


export async function fetchNamesFromOpenSea(
    uid: string,
): Promise<string[]> {
    const url = `https://api.opensea.io/api/v1/assets?owner=${uid}&order_direction=desc&limit=50&collection=dcl-names`,
        response = await fetch(url);
    if (response.status !== 200) {
        return [];
    }
    const {assets} = await response.json();
    return assets
        .filter(
            (item: any) => item.collection.slug === 'dcl-names',
        )
        .map((asset: any) => asset.name)
        .sort();
}


export async function getDCLProfile(
    uid: string,
): Promise<IDCLProfile | null> {
    const baseUrl =
        'https://peer-lb.decentraland.org/lambdas/profile/';
    return fetch(baseUrl + uid)
        .then((response) => response.json())
        .then((data) =>
            data.avatars[0]
                ? parseDCLProfile(data.avatars[0])
                : null,
        )
        .catch((err) => {
            console.warn(err.message);
            return null;
        });
}


function parseDCLProfile(data: any): {
    avatar: IAvatar;
    name: string;
} {
    const {
        avatar: {snapshots},
        name,
        unclaimedName,
        hasClaimedName,
    } = data;
    return {
        avatar: snapshots,
        name: hasClaimedName ? name : unclaimedName,
    };
}
